import * as React from 'react';

import {BulletedList} from '../bulleted-list/bulleted-list';
import {Button} from '../button/button';
import {Illustration} from '../illustrations/illustration';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {Link} from '../link/link';
import {Body} from '../typography/body';

import {TwoPaneModal} from './two-pane-modal';

import styles from './quote-and-invoice-info-modal.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function QuoteAndInvoiceInfoModal(props: Props) {
    const bullets = [
        'Create from a lead with one click',
        'Share via link, email or PDF',
        'Track views and status updates',
        'Seamlessly move from quote to invoice',
        'Unlimited quotes and invoices',
    ];

    return (
        <TwoPaneModal
            // @ts-expect-error
            isOpen={props.isOpen}
            onClose={props.onClose}
            maxHeight={600}
            minWidth={820} // Make title fit on one line
            closeButton={false}
            leftSection={
                <div className={styles['modal-left-section']}>
                    <Illustration src='quote-and-invoice' width={300} />
                </div>
            }
            rightSection={
                <>
                    <div className='pad-32 align-self-center'>
                        <StackLegacy spacing={16}>
                            <Body size='xlarge' isBold={true}>
                                Send quotes and invoices in a snap
                            </Body>
                            <Body>
                                With Nutshell, you can quickly create and send quotes or invoices —
                                complete with your company’s details, product info, and pricing.
                            </Body>
                            <BulletedList
                                bullets={bullets}
                                greyBullets={true}
                                marginBottom={0}
                                lessSpacing={true}
                            />
                            <div className='mt-4 flex flex-dir-col gap-16'>
                                <Body>Available for $67/month for your entire company.</Body>
                                <Link
                                    href='https://support.nutshell.com/en/articles/10616834-set-up-and-use-nutshell-quotes-to-create-share-and-manage-quotes-for-your-leads'
                                    variant='primary'
                                    // @ts-expect-error
                                    target='_blank'
                                >
                                    Learn more on our knowledge base
                                </Link>
                            </div>
                        </StackLegacy>
                        <div className={styles['done-button']}>
                            <Button onClick={props.onClose} variant='primary'>
                                Done
                            </Button>
                        </div>
                    </div>
                </>
            }
        />
    );
}
